import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const forWho = ['Moms of children aged 3–8 who are tired of the daily "Screen-Time Battle."', 'Working or WFH parents who need a reliable block of time to finish tasks or cook.', "Parents who want to foster independent play but don't want a messy house.", 'Anyone struggling with the 5 PM "Witching Hour" chaos.'];
const notForWho = ['Parents looking for an academic or school-prep curriculum.', 'Those who prefer complex, expensive Montessori setups.', "Families who aren't interested in reducing daily screen time."];
export function WhoItsFor() {
  return <section className="bg-white py-24 sm:py-32" data-id="element-217">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-218">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8" data-id="element-219">
          {/* For Who */}
          <FadeIn direction="right" data-id="element-220">
            <div className="bg-teal-light/30 rounded-3xl p-8 sm:p-10 h-full border border-teal-light" data-id="element-221">
              <h3 className="font-serif text-2xl font-bold text-navy mb-8" data-id="element-222">
                This is for you if...
              </h3>
              <ul className="space-y-6" data-id="element-223">
                {forWho.map((item, index) => <li key={index} className="flex gap-4" data-id="element-224">
                    <CheckCircle2 className="h-6 w-6 text-teal shrink-0 mt-0.5" data-id="element-225" />
                    <span className="text-navy-light font-medium leading-relaxed" data-id="element-226">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For Who */}
          <FadeIn direction="left" delay={0.2} data-id="element-227">
            <div className="bg-gray-50 rounded-3xl p-8 sm:p-10 h-full border border-gray-100" data-id="element-228">
              <h3 className="font-serif text-2xl font-bold text-muted mb-8" data-id="element-229">
                This might not be for you if...
              </h3>
              <ul className="space-y-6" data-id="element-230">
                {notForWho.map((item, index) => <li key={index} className="flex gap-4 opacity-80" data-id="element-231">
                    <XCircle className="h-6 w-6 text-muted-light shrink-0 mt-0.5" data-id="element-232" />
                    <span className="text-muted leading-relaxed" data-id="element-233">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}